/**
 * Vehicle feature descriptions for inline filter promo cards
 * Provides user-friendly explanations of vehicle features to help with decision making
 */

export const VEHICLE_FEATURE_DESCRIPTIONS = {
    'Bluetooth, Hands-Free': 'Make and receive calls safely through your car\'s audio system without touching your phone.',
    'Backup Camera': 'See behind your vehicle while reversing with a live video feed to avoid obstacles.',
    'Security System': 'Alerts you with a loud alarm if someone tries to break into your vehicle.',
    'Security/Alarm System': 'Alerts you with a loud alarm if someone tries to break into your vehicle.',
    'Adaptive Cruise Control': 'Automatically adjusts your speed to maintain a safe distance from the car ahead.',
    'Premium Audio': 'Enjoy high-quality sound with advanced speakers for a better listening experience.',
    'Premium Audio System': 'Enjoy high-quality sound with advanced speakers for a better listening experience.',
    'Cross Traffic Alert': 'Warns you of approaching vehicles from the sides when backing out of a parking spot.',
    'Rear Cross-Traffic Alert': 'Warns you of approaching vehicles from the sides when backing out of a parking spot.',
    'Lane Departure Warning': 'Alerts you if your car begins to drift out of its lane without signaling.',
    'Keyless Start': 'Start your car with the push of a button while the key fob stays in your pocket or bag.',
    'Remote Engine Start': 'Start your car from a distance to preheat or cool the cabin before you get in.',
    'WiFi Hotspot': 'Keep passengers connected with in-car internet powered by a paid data plan.',
    'Heated Seats': 'Stay warm with built-in seat heaters during cold weather.',
    'Apple CarPlay/Android Auto': 'Use your phone hands-free for calls, maps, music, and more via the car\'s touchscreen.',
    'Sunroof/Moonroof': 'Let in fresh air and light with roof panels that open or tilt.',
    'Leather Seats': 'Add a premium touch with stylish, easy-to-clean leather seating.',
    'Automatic Parking': 'Park effortlessly as your car steers itself into a spot using sensors.',
    'Satellite Radio': 'Access a wide range of clear-sounding channels wherever you drive.',
};

/**
 * Get description text for a vehicle feature
 * @param {string} featureName - The name of the vehicle feature
 * @returns {string|null} The description or null if not found
 */
export const getFeatureDescription = (featureName) => VEHICLE_FEATURE_DESCRIPTIONS[featureName] || null;

export default VEHICLE_FEATURE_DESCRIPTIONS;
